<template>
  <div>
    <section>
      <div id="launch" class="biggest-creators">
        <div class="left-part">
          <h1>Join some of the biggest creators in the country</h1>
          <p>
            Filipino creators are earning directly from their fans with
            HelixPay's e-commerce tools.
          </p>
          <div class="clients">
            <img src="img/pna-logo.svg" alt="Avatar" class="image" />
            <img src="img/penlab-logo.svg" alt="Avatar" class="image" />
            <img src="img/t1-logo.svg" alt="Avatar" class="image" />
            <img src="img/kumu-logo.png" alt="Avatar" class="image" />
          </div>
        </div>
        <div class="right-part">
          <div class="creator-info">
            <img src="/img/aryn-min.jpg" alt="Avatar" class="image" />
            <div>
              <h3>Aryn Cristobal</h3>
              <p>110,000 TikTok Followers</p>
            </div>
          </div>
          <div class="creator-info">
            <img src="img/spart-min.jpg" alt="Avatar" class="image" />
            <div>
              <h3>Spart Farnacio</h3>
              <p>646K Youtube Subscribers</p>
            </div>
          </div>
          <div class="creator-info">
            <img src="img/nuggets-min.jpg" alt="Avatar" class="image" />
            <div>
              <h3>Nisa Nuggets</h3>
              <p>337K Youtube Subscribers</p>
            </div>
          </div>
          <div class="creator-info">
            <img src="img/adamalejo-min.jpg" alt="Avatar" class="image" />
            <div>
              <h3>Adam Alejo</h3>
              <p>1.1M Youtube Subscribers</p>
            </div>
          </div>
        </div>
      </div>

      <div class="calculator">
        <div class="calculator-info">
          <h1>Calculate your potential earnings!</h1>
          <router-link to="/incomecalculator" style="text-decoration: none">
            <p>Income Calculator</p>
          </router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped>
.calculator {
  width: 100%;
  padding: 3rem 0;
}

.calculator-info {
  max-width: 60rem;
  margin: auto;
}

.calculator-info h1 {
  font-size: 2.5rem;
  font-weight: 700;
}

.calculator-info p {
  width: fit-content;
  margin: auto;
  color: white;
  font-size: 1.5rem;
  font-weight: 600;
  text-decoration: none;
  padding: 1rem 2rem;
  border-radius: 5px;
  transition: 0.2s ease-in;
  background-color: #ff5f8f;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
}

.calculator-info p:hover {
  transform: translateY(-7px);
  background-color: #eb4c7b;
}

section {
  width: 100%;
  padding: 3rem 2rem;
  text-align: center;
}

.biggest-creators {
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 3.5rem;
  max-width: 60rem;
  margin: auto;
  text-align: center;
  padding: 3rem 0;
}

.clients {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-top: 3rem;
}

.clients img {
  max-width: 12rem;
  display: flex;
  margin: auto;
  justify-content: center;
}

.left-part {
  text-align: left;
}

.left-part h1 {
  font-weight: 700;
  font-size: 3.5rem;
  line-height: 1.25;
  margin: 0;
}

.left-part p {
  font-weight: 500;
  font-size: 1.2rem;
  line-height: 1.25;
  margin-top: 2rem;
  opacity: 0.5;
}

.right-part {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
}

.creator-info {
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  gap: 0;
  align-items: center;
}

.creator-info img {
  width: 70%;
  display: block;
  margin: auto;
  border-radius: 5px;
}

.creator-info div {
  display: grid;
  gap: 0;
}

.creator-info div h3 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #ff5f8f;
}

.creator-info div p {
  font-weight: 600;
  opacity: 0.5;
}

@media only screen and (max-width: 900px) {
  .biggest-creators {
    grid-template-columns: 1fr;
    gap: 3.5rem;
  }

  .creator-info img {
    width: 100%;
  }

  .clients img {
    max-width: 10rem;
  }

  .left-part {
    text-align: center;
  }

  .calculator-info h1 {
    font-size: 2rem;
  }

  .calculator-info p {
    font-size: 1.25rem;
  }

  .left-part h1 {
    font-size: 2rem;
  }

  .left-part p {
    font-size: 1rem;
  }

  .creator-info {
    gap: 2rem;
  }

  .clients {
    gap: 3rem;
  }
}

@media only screen and (max-width: 700px) {
  .creator-info div h3 {
    font-size: 1.2rem;
  }

  .creator-info div p {
    font-size: 0.7rem;
  }

  .clients img {
    width: 100%;
  }
}
</style>
